import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import './App.css';
import Header from './header';
import Home from './home';
import Private from './private';
import PrivateRoute from './PrivateRoute';
import TeamParticipantsDashboard from './dashboard';
import UserDashboard from './UserDashboard';
import ManagerDashboard from './ManagerDashboard';
import SignInPage from './SignInPage';

function App() {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('=== APP STATE DEBUG ===');
    console.log('Current URL:', window.location.href);
    console.log('Location pathname:', location.pathname);
    console.log('AuthState:', authState);
    console.log('OktaAuth instance:', oktaAuth);
    
    // Check if we have tokens in storage using the correct methods
    if (oktaAuth) {
      try {
        const accessToken = oktaAuth.getAccessToken();
        const idToken = oktaAuth.getIdToken();
        console.log('Access token from storage:', accessToken ? 'Present' : 'None');
        console.log('ID token from storage:', idToken ? 'Present' : 'None');
      } catch (error) {
        console.log('Error getting tokens:', error.message);
      }
    }
  }, [authState, oktaAuth, location.pathname]);

  useEffect(() => {
    const isCallbackRoute = location.pathname.startsWith('/authorization-code/callback');
    const isLoginRoute = location.pathname === '/login';
    const hasSimpleAuth = sessionStorage.getItem('simpleAuth') === 'true';
    
    console.log('=== REDIRECT LOGIC ===');
    console.log('Is callback route:', isCallbackRoute);
    console.log('Is login route:', isLoginRoute);
    console.log('Has simple auth:', hasSimpleAuth);
    console.log('AuthState exists:', !!authState);
    console.log('Is authenticated:', authState?.isAuthenticated);
    console.log('Is pending:', authState?.isPending);
    
    // If user is authenticated (either Okta or simple auth) and not on callback/login route
    if ((authState?.isAuthenticated || hasSimpleAuth) && !isCallbackRoute && !isLoginRoute) {
      // If on root path, redirect to dashboard
      if (location.pathname === '/') {
        navigate('/dashboard');
      }
    }

    // If not authenticated and not on callback, login, or dashboard route, redirect to login
    const isDashboardRoute = location.pathname === '/dashboard';
    if (
      authState &&
      !authState.isAuthenticated &&
      !hasSimpleAuth &&
      !authState.isPending &&
      !isCallbackRoute &&
      !isLoginRoute &&
      !isDashboardRoute
    ) {
      console.log('Redirecting to login page...');
      navigate('/login');
    }
  }, [authState, navigate, location]);

  // Handle callback route
  if (location.pathname.startsWith('/authorization-code/callback')) {
    console.log('On callback route, showing LoginCallback component');
    return <LoginCallback />;
  }

  // Show loading while authState is initializing
  if (!authState) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Initializing authentication...</div>
      </div>
    );
  }

  // Show loading while authentication is pending
  if (authState.isPending) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Processing authentication...</div>
        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          Please wait while we complete the sign-in process...
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <Routes>
        <Route path="/login" element={<SignInPage />} />
        <Route path="/authorization-code/callback" element={<LoginCallback />} />
        <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/private" element={<PrivateRoute><Private /></PrivateRoute>} />
        <Route path="/dashboard" element={<TeamParticipantsDashboard />} />
        <Route path="/user" element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
        <Route path="/manager" element={<PrivateRoute><ManagerDashboard /></PrivateRoute>} />
      </Routes>
    </>
  );
}

export default App;
